import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Dialog } from 'components/ui'
import { WELCOME_MESSAGE_SHOWN_KEY } from 'constants/system.constant'
import { BsInfoSquareFill } from 'react-icons/bs'

const WelcomeMessage = () => {
  const welcomeMessage = useSelector((state) => state.systemConfig?.data?.welcomeMessage)
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    // Show dialog if welcomeMessage exists and hasn't been shown in this session
    if (welcomeMessage) {
      const hasShown = sessionStorage.getItem(WELCOME_MESSAGE_SHOWN_KEY)
      if (!hasShown) {
        setIsOpen(true)
        sessionStorage.setItem(WELCOME_MESSAGE_SHOWN_KEY, 'true')
      }
    }
  }, [welcomeMessage])

  const handleClose = () => {
    setIsOpen(false)
  }

  if (!welcomeMessage) {
    return null
  }

  return (
    <Dialog
      isOpen={isOpen}
      onClose={handleClose}
      onRequestClose={handleClose}
      width={500}
    >
      <div className="px-6">
        <div className="flex items-center gap-4">
          <BsInfoSquareFill className="min-w-8 min-h-8 text-blue-500" /><p className="whitespace-pre-wrap">{welcomeMessage}</p>
        </div>
      </div>
    </Dialog>
  )
}

export default WelcomeMessage
